<template>
    <template-layout :is-hide-menu="true">
        <div class="grid grid-cols-12 gap-6 py-12 pb-0 h-full">
            <div class="md:col-span-9 col-span-12" v-if="newsData">
                <div v-if="newsData.IMAGE_URL" class="mb-5 aspect-ratio-image">
                    <img class="rounded-md" :src="newsData.IMAGE_URL" alt="" />
                </div>
                <h1 class="text-2xl text-theme-1 mb-5">
                {{newsData.TITLE}}
                </h1>
                <div class="flex mb-5 text-gray-500 items-center gap-1">
                    <CalendarIcon class="w-4 h-4"/>
                    <div>
                        <p class="mb-0">
                            {{
                                new Date(newsData.createdAt).toLocaleDateString("th-TH", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })
                            }}
                        </p>
                    </div>
                </div>
                <div class="article-detail">
                    <div v-html="newsData.DETAIL"></div>
                </div>
            </div>
            <div class="md:col-span-3 col-span-12 px-3 rounded-lg bg-[#1c32710f]" v-if="suggestNews">
                <h2 class="text-xl my-3 text-center">ข่าวสาร/ประกาศอื่น</h2>
                <SuggestNewsItem v-for="(data,key) in suggestNews" :key="key" :data="data" />
            </div>
        </div>
    </template-layout>
</template>

<script setup>
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import {onMounted, ref, watch } from 'vue'
import axios from "axios"
import { useRoute } from 'vue-router'
import SuggestNewsItem from "./container/SuggestNewsItem.vue"

const route = useRoute()
const newsData = ref(null)
const suggestNews = ref([])
const getNews = () =>{
    const config = {
        url: `${process.env.VUE_APP_BASE_API}news/${route.params.id}`,
        method: "GET"
    };
    axios(config)
    .then((response) => {
        newsData.value = response.data
    })
    .catch((error)=>{
        console.log(error);
    })
}
const getSuggestNews = () =>{
    const config = {
        url: `${process.env.VUE_APP_BASE_API}news/getSuggestNews/`,
        method: "POST",
        data:{
            id: route.params.id,
            CATEGORY: "ข่าวสาร/ประกาศอื่น",
            start: 1,
            length: 5,
            sorters:[
                {
                    field: "createdAt",
                    dir: "desc"
                }
            ]
        }
    };
    axios(config)
    .then((response) => {
        suggestNews.value = response.data.data
    })
    .catch((error)=>{
        console.log(error);
    })
}
onMounted(()=>{
    getNews()
    getSuggestNews()
})
watch(()=>route.params.id,()=>{
    getNews()
    getSuggestNews()
})
</script>

<style lang="scss">
.aspect-ratio-image{
    position: relative;
    &:after{
        display: block;
        content: "";
        padding-bottom: 40%;
    }
    img{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: middle;
    }
}

</style>